import React from 'react';
import { useTranslation } from 'react-i18next';
import { colors } from '@guryou/colors';
import Mockup from '../../../assets/img/mockup.webp';
import { Icon } from '../../../components/shared';

const CTASection = () => {
  const { t } = useTranslation();

  return (
    <section className="py-16 lg:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Left Content */}
          <div>
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight mb-6" style={{ color: colors.mineShaft }}>
              {t('CTA_SECTION.title')}
            </h2>
            <p className="text-xl leading-relaxed mb-8 max-w-2xl text-gray-600">{t('CTA_SECTION.description')}</p>

            {/* Download Buttons */}
            <div className="flex flex-col sm:flex-row gap-3 sm:gap-4">
              <a
                href="/"
                className={`inline-flex items-center justify-center px-4 py-3 sm:px-6 sm:py-4 text-white rounded-xl sm:rounded-lg transition-all duration-300 hover:scale-105 group shadow-lg w-full sm:w-auto bg-[var(--feel-primary)] hover:bg-[var(--feel-primary-dark)]`}
              >
                <Icon name="app-store" size="lg" className="mr-2 sm:mr-3" />
                <div className="text-center sm:text-left">
                  <div className="text-xs sm:text-sm opacity-90">{t('CTA_SECTION.appStore.subtitle')}</div>
                  <div className="text-sm sm:text-lg font-semibold">{t('CTA_SECTION.appStore.title')}</div>
                </div>
              </a>

              <a
                href="/"
                className={`inline-flex items-center justify-center px-4 py-3 sm:px-6 sm:py-4 text-white rounded-xl sm:rounded-lg transition-all duration-300 hover:scale-105 group shadow-lg w-full sm:w-auto bg-[${colors.mineShaft}] hover:bg-[${colors.brownMineShaft}]`}
              >
                <Icon name="google-play" size="lg" className="mr-2 sm:mr-3" />
                <div className="text-center sm:text-left">
                  <div className="text-xs sm:text-sm opacity-90">{t('CTA_SECTION.googlePlay.subtitle')}</div>
                  <div className="text-sm sm:text-lg font-semibold">{t('CTA_SECTION.googlePlay.title')}</div>
                </div>
              </a>
            </div>
          </div>

          {/* Right Content - Phone Mockup */}
          <div className="flex justify-center lg:justify-end">
            <div className="relative">
              {/* Phone Frame */}
              <div className="relative w-80 h-[600px] rounded-[3rem] p-2 shadow-2xl" style={{ backgroundColor: colors.mineShaft }}>
                {/* Phone Screen */}
                <div
                  className="w-full h-full rounded-[2.5rem] relative overflow-hidden"
                  style={{
                    background: `linear-gradient(135deg, ${colors.carouselPink}40, color-mix(in srgb, var(--feel-primary) 25%, transparent), color-mix(in srgb, var(--feel-primary-dark) 25%, transparent))`,
                  }}
                >
                  {/* Screen Content */}
                  <div className="absolute inset-0 flex items-center justify-center">
                    <div
                      className="w-32 h-32 rounded-full opacity-20 animate-pulse"
                      style={{ background: `linear-gradient(45deg, ${colors.carouselPink}, var(--feel-primary))` }}
                    ></div>
                  </div>

                  {/* App Mockup Image */}
                  <div className="absolute inset-4 rounded-[2rem] overflow-hidden">
                    <img src={Mockup} alt="App Mockup" className="w-full h-full object-cover" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
